import classnames from 'classnames';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Translate, withLocalize } from 'react-localize-redux';
import ModalInner from '../layoutItems/modalInner';

class WarningMessagePopup extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate('Common.Warning')} close={this.props.close}>
                <br />
                <div>{ReactHtmlParser(this.props.message)}</div>
                <br />
                <div>{this.props.translate('Common.Continue.Question')}</div>
                <br />
                <div className="modal-inner-buttons">
                    <button onClick={() => this.props.close()} className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id="Common.No.Upper" />
                    </button>
                    <button onClick={() => this.props.onConfirm()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                        <Translate id="Common.Yes.Upper" />
                    </button>
                </div>
            </ModalInner>
        )
    }
}

export default withLocalize(WarningMessagePopup);
